import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from '../components/HeaderNew';
import Footer from '../components/Footer';
import Contact from '../components/Contact';
import Virginia from '../components/Virginia';
import Marijuana from '../components/Marijuana-dispensaries';
import Homepage from '../components/Homepage';
import Tourpage from '../components/Tourpage';
import Signup from '../components/Signup';
import Login from '../components/Login';
import Cart from '../components/Cart';
import Business from '../components/BusinessPage';
import SearchBusiness from '../components/SearchBusiness';
import SearchStrains from '../components/SearchStrains';
import Profile from '../components/Profile';
import JoinUs from '../components/Signup/JoinUs';
import Authenticate from './Authenticate';
import AuthenticateAllow from './AuthenticateAllow';
import Logout from '../components//Login/Logout';
import 'react-toastify/dist/ReactToastify.css';
import Blog from '../components/blog';
import News from '../components/News';
import SearchDeals from '../components/SearchDeals';
import BusinessPageNew from '../components/BusinessPageNew';

export default class Index extends Component {
    render() {
        return (
                <div className="index_wrapper" >
                    <Header />
                    <Routes>
                        <Route path='/business/:id' element={<AuthenticateAllow Component={<Business />} role='BUYER' />} />
                        <Route path='/businessnew/:id' element={<AuthenticateAllow Component={<BusinessPageNew />} role='BUYER' />} />
                        <Route path='/search' element={<SearchBusiness />} />
                        <Route path='/contact' element={<Contact />} />
                        <Route path='/strain' element={<SearchStrains />} />
                        <Route path='/deals' element={<SearchDeals />} />
                        <Route path='/blog' element={<Blog />} />
                        <Route path='/news' element={<News />} />
                        <Route path='/join' element={<JoinUs />} />
                        <Route path='/signup' element={<Signup />} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/cart' element={<AuthenticateAllow Component={<Cart />} role='BUYER' />} />
                        <Route path='/tour' element={<Tourpage />} />
                        <Route path='/profile/*' element={<Authenticate Component={<Profile />} />} />
                        <Route path='/virginia' element={<Virginia />} />
                        <Route path='/marijuana' element={<Marijuana />} />
                        <Route path='/' element={<AuthenticateAllow Component={<Homepage />} role='BUYER' />} />
                        <Route path='/logout' element={<Logout />} />
                    </Routes>
                    <Footer />
                </div>
        );
    }
}


